import { render, staticRenderFns } from "./TableLovers.vue?vue&type=template&id=29f9d111&"
import script from "./TableLovers.vue?vue&type=script&lang=js&"
export * from "./TableLovers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports